package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.redesign.components.rdFaqJsonLd
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.SITE_URL
import com.anjuros.website.templates.selection.util.Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.selection.util.Constants.CLIENTS_FB_LINK

/** JSON-LD for the homepage: the business and the FAQ, so Google can show them in results. */
@Composable
fun homeStructuredData(): String {
    val faq = rdFaqJsonLd(HomeFaqs)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"ProfessionalService","@id":"$SITE_URL/#business","name":"Anjuros Development","url":"$SITE_URL/",
          "logo":"$SITE_URL${RdImage.LOGO.src}","email":"$CLIENTS_EMAIL","telephone":"+447497599150","areaServed":"GB",
          "description":"Website design for UK sole traders, with a Job Management Portal that turns enquiries into organised jobs.",
          "sameAs":["$CLIENTS_FB_LINK"]},
         $faq
        ]}
    """.trimIndent()
}
